import PlanCompile from "./PlanCompile";
import { useEffect } from "react";
import { usePlanCompileStore } from "../../store/plan-compile.store";

function PlanCompileContainer({ userRole, ...props }) {
	const resetData = usePlanCompileStore((state) => state.reset);

	useEffect(() => {
		return () => {
			resetData();
		};
	}, []);

	return <PlanCompile {...props} role={userRole} />;
}

export default PlanCompileContainer;
